import Image from "next/image";
import type Project from "@/types/project";
import StackBadges from "@/components/common/StackBadges";

type ProjectCardProps = {
  project: Project;
  onOpenProject?: (projectId: string) => void;
};

export default function ProjectCard({
  project,
  onOpenProject,
}: ProjectCardProps) {
  return (
    <div
      className="card group cursor-pointer flex h-full min-h-0 flex-col"
      onClick={() => onOpenProject?.(project.id)}
    >
      <div className="shrink-0 p-1">
        <div className="w-full relative rounded-[28px] overflow-hidden border border-white/15 aspect-video">
          <Image
            src={project.image}
            alt={project.title}
            fill
            sizes="(max-width: 768px) 92vw, (max-width: 1024px) 45vw, 33vw"
            className="w-full h-full object-contain transition-all duration-700 scale-105"
            loading="lazy"
            quality={75}
          />
        </div>
      </div>
      <div className="flex min-h-0 flex-1 flex-col p-5 pt-3">
        <div className="min-w-0 w-full shrink-0 space-y-2">
          <h3
            className="truncate text-3xl font-headline font-bold text-on-surface"
            title={project.title}
          >
            {project.title}
          </h3>
          <p
            className="line-clamp-2 text-on-surface-variant leading-relaxed"
            title={project.description}
          >
            {project.description}
          </p>
        </div>
        <div className="mt-auto shrink-0 pt-2">
          <StackBadges names={project.tags} />
        </div>
      </div>
    </div>
  );
}
